module.exports = __webpack_public_path__ + "static/my_logo_proper-33e862ac5cc06732e303a582465b6fbe.png";